import { z } from 'zod';

export type DraftState = 'new' | 'updated' | 'deleted' | 'unchanged';

export const draftStateSchema = z.union([
  z.literal('new'),
  z.literal('updated'),
  z.literal('deleted'),
  z.literal('unchanged'),
]);

export type TalkParticipantType = 'internal' | 'external';

export const talkParticipantDraftSchema = z.object({
  type: z.union([z.literal('internal'), z.literal('external')]),
  userId: z.string().nullable().optional(), // internal
  email: z.string().nullable().optional(), // external

  // UI-only
  _state: draftStateSchema.optional(),
});

export type ITalkParticipantDraft = z.infer<typeof talkParticipantDraftSchema>;

export const legalTransactionTalkRoomDraftSchema = z.object({
  idLegalTransactionTalkRoom: z.number(),
  idLegalTransaction: z.number(),

  RoomName: z.string(),
  roomType: z.number().optional(),

  Token: z.string().nullable(),
  JoinUrl: z.string().nullable(),
  CreatedAt: z.string().nullable(),
  DeletedAt: z.string().nullable(),

  Participants: z.array(talkParticipantDraftSchema).optional(),

  _state: draftStateSchema.optional(),
});

export type ILegalTransactionTalkRoomDraft = z.infer<
  typeof legalTransactionTalkRoomDraftSchema
>;

export const getNextNegativeTalkRoomId = (
  rooms: ILegalTransactionTalkRoomDraft[]
) => {
  const minId = rooms.length
    ? Math.min(...rooms.map(r => r.idLegalTransactionTalkRoom))
    : 0;
  return minId <= 0 ? minId - 1 : -1;
};

export const createTalkRoomDraft = ({
  talkRooms,
  idLegalTransaction,
  roomName,
}: {
  talkRooms: ILegalTransactionTalkRoomDraft[];
  idLegalTransaction: number;
  roomName: string;
}): ILegalTransactionTalkRoomDraft => ({
  idLegalTransactionTalkRoom: getNextNegativeTalkRoomId(talkRooms),
  idLegalTransaction,
  RoomName: roomName.trim(),
  roomType: 3,
  Token: null,
  JoinUrl: null,
  CreatedAt: null,
  DeletedAt: null,
  Participants: [],
  _state: 'new',
});
